'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('cookieService', [
      '$cookies',
      '$document',
      function(
        $cookies,
        $document,
      ) {
        function retailTourTaken(value) {
          if (angular.isUndefined(value)) {
            return $cookies.get('retail-tour-taken') == 'true';
          } else{
            $cookies.put('retail-tour-taken', value);
          }
        }

        //returns true, false, undefined
        function rememberUser(value) {
          if (angular.isUndefined(value)) {
            return $cookies.get('retail-remember-user') == undefined ? undefined : $cookies.get('retail-remember-user') == 'true';
          } else{
            $cookies.put('retail-remember-user', value);
          }
        }

        function loginName(value) {
          if (angular.isUndefined(value)) {
            return $cookies.get('retail-login-name') ;
          } else{
            $cookies.put('retail-login-name', value);
          }
        }

        function deleteCookie(name) {
        //Delete cookie if on current domain
          $cookies.remove(name, {
            path:'/',
            domain: $document.domain
          });
          //Delete on superdomain
          $cookies.remove(name, {
            path:'/',
            domain: '.fetchtv.com.au'
          });
        }

        /* ---------- Integration related ----------- */
        function deleteAuthenticationCookies() {
          ([
            'FetchSubscriberId',
            'auth',
            'user',
            'c'
          ]).forEach(deleteCookie);
        }

        function deleteMWAuthCookie() {
          deleteCookie('auth');
        }

        function getMWAuthCookie() {
          return $cookies.get('auth');
        }

        function cookieBannerClosed(value) {
          if (angular.isDefined(value)) {
            $cookies.put('cookie-banner-closed', value, {path: '/'});
          }
          var cookieVal = $cookies.get('cookie-banner-closed');
          return cookieVal;
        }

        return {
          retailTourTaken: retailTourTaken,
          rememberUser: rememberUser,
          loginName: loginName,
          deleteAuthenticationCookies: deleteAuthenticationCookies,
          getMWAuthCookie: getMWAuthCookie,
          deleteMWAuthCookie: deleteMWAuthCookie,
          cookieBannerClosed: cookieBannerClosed

        };
      }]);
})(angular);
